// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { tgfAudio } from "../../framework/tgfAudio";
import { tgfFunctions } from "../../framework/tgfFunctions";
import { explosionTypeBlackBird } from "../../settings/Explosion";
import { PhysicsSettings } from "../../settings/PhysicsSettings";
import { ReplayLogger } from "../ReplayLogger";
import { globalAddExplosion } from "../SceneController";
import { playController } from "../gameController";
import { BirdObjectDefault } from "./BirdObject";
export function BirdObjectBlack(def, uid, x, y, angle, container) {
    BirdObjectBlack.uber.constructor.call(this, def, uid, x, y, angle, container);
    this.explosionTimer = -1;
    var self = this;
    this.onFirstContact = function () {
        ReplayLogger.log("First Contact");
        self.impactEffect();
        if (self.canUsePower) {
            self.explosionTimer = PhysicsSettings.blackBirdExplosionTime;
        }
    };
}
tgfFunctions.inherit(BirdObjectBlack, BirdObjectDefault);
BirdObjectBlack.prototype.activateSpecialPower = function (unused) {
    if (this.canUsePower) {
        tgfAudio.stop("game");
        this.playSound(this.soundStates.ABILITY, this.definition.sounds);
        this.canUsePower = false;
        globalAddExplosion(this.x, this.y, explosionTypeBlackBird);
        ReplayLogger.log("BOOM");
        for (var i = 0; i < playController.sceneController.balls.length; i++) {
            if (playController.sceneController.balls[i] == this) {
                playController.sceneController.balls.splice(i, 1);
                break;
            }
        }
        this.destroy();
        return true;
    }
    return false;
};
BirdObjectBlack.prototype.physicsStep = function () {
    "use strict";
    BirdObjectBlack.uber.physicsStep.call(this);
    if (this.explosionTimer > 0) {
        this.explosionTimer -= 1;
        if (this.explosionTimer <= 0) {
            this.explosionTimer = 0;
            this.needToActivateSpecialPower = true;
        }
    }
};
BirdObjectBlack.prototype.isActive = function () {
    if (this.explosionTimer > 0 || this.needToActivateSpecialPower) {
        return true;
    }
    else {
        return BirdObjectBlack.uber.isActive.call(this);
    }
};
BirdObjectBlack.prototype.destroyEffect = function () {
    "use strict";
    //Black bird has no puff effect
};
BirdObjectBlack.prototype.impactEffect = function () {
    "use strict";
    BirdObjectBlack.uber.impactEffect.call(this);
    this.image.setAnimation("bomb_hit", true);
};
BirdObjectBlack.prototype.spineInit = function () {
    "use strict";
};
